// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4a719acd","453":"a82c4221","455":"63d1f05a"}[chunkId] + ".chunk.js";
};